import { render } from "./IconLoader.vue?vue&type=template&id=d400d314&scoped=true"
const script = {}

import "./IconLoader.vue?vue&type=style&index=0&id=d400d314&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d400d314"]])

export default __exports__